import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-simple-quiz-problem-reporting-rw',
  templateUrl: './page-activity-simple-quiz-problem-reporting-rw.component.html',
  styleUrls: ['./page-activity-simple-quiz-problem-reporting-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageActivitySimpleQuizProblemReportingRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  flag = false;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  model = {
    question1: undefined,
    question2: undefined,
    question3: undefined,
    question4: undefined,
    question5: undefined,
    question6: undefined,
    question7: undefined,
    question8: undefined,

  };

  question1Picked = false;
  question2Picked = false;
  question3Picked = false;
  question4Picked = false;
  question5Picked = false;
  question6Picked = false;
  question7Picked = false;
  question8Picked = false;

  question1() {
    this.question1Picked = true;
    console.log(this.model.question1);
    console.log(typeof(this.model.question1));
  }
  question2() {
    this.question2Picked = true;
  }
  question3() {
    this.question3Picked = true;
  }
  question4() {
    this.question4Picked = true;
  }
  question5() {
    this.question5Picked = true;
  }
  question6() {
    this.question6Picked = true;
  }
  question7() {
    this.question7Picked = true;
  }
  question8() {
    this.question8Picked = true;
  }

  activityOneCorrect()
  {
    /*
      If a question is not picked, return false
    */
   if (!this.question1Picked || !this.question2Picked ||  !this.question3Picked || !this.question4Picked || !this.question5Picked
      || !this.question6Picked || !this.question7Picked || !this.question8Picked)
   {
      return false;
   }

   if (this.model.question1 == true  || this.model.question2 == true  || this.model.question3 == true  || this.model.question4 == true
      || this.model.question5 == true  || this.model.question6 == true  || this.model.question7 == true  || this.model.question8 == true )
      //If any are true, then return false
   {
    return false;
   }

   /*
    Default: return true
   */
   return true;
  }

  setFlag()
  {
    this.flag = true;
  }
  resetFlag()
  {
    this.flag = false;
  }
}
